// Mock support requests. Shared by Support Requests and the Dashboard.
// No backend endpoint exists yet.
const INITIAL_REQUESTS = [
  {
    id: 1,
    name: "Ama Boateng",
    email: "ama.boateng@example.com",
    subject: "Unable to reset my password",
    message:
      "I've tried resetting my password three times but the reset link never arrives in my inbox. Can you help?",
    submittedAt: "2026-06-28",
    status: "pending",
  },
  {
    id: 2,
    name: "Kwame Mensah",
    email: "kwame.mensah@example.com",
    subject: "Charged twice for subscription",
    message:
      "My card was charged twice this month for the same subscription plan. Please refund the duplicate charge.",
    submittedAt: "2026-06-29",
    status: "pending",
  },
  {
    id: 3,
    name: "Efua Owusu",
    email: "efua.owusu@example.com",
    subject: "How do I delete my account?",
    message: "I'd like to permanently delete my account and all associated data. What's the process?",
    submittedAt: "2026-06-30",
    status: "replied",
  },
];

export default INITIAL_REQUESTS;
